import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const NotFound = () => {
  return (
    <div className="min-h-screen w-full bg-white font-sans">
      <Navbar />
      <main className="flex min-h-[80vh] flex-col items-center justify-center px-4 pt-32 pb-16 md:pt-40">
        <svg
          viewBox="0 0 560 320"
          role="img"
          aria-label="404 error page"
          className="w-full max-w-[560px] text-[var(--primary)]"
        >
          <circle cx="70" cy="70" r="14" fill="#e5e7eb" />
          <circle cx="500" cy="60" r="18" fill="#e5e7eb" />
          <circle cx="40" cy="220" r="20" fill="#e5e7eb" />
          <circle cx="520" cy="210" r="12" fill="#e5e7eb" />
          <ellipse cx="280" cy="290" rx="40" ry="10" fill="#e5e7eb" />
          <ellipse cx="120" cy="270" rx="34" ry="20" fill="#1f2937" transform="rotate(-20 120 270)" />
          <ellipse cx="450" cy="270" rx="30" ry="18" fill="#1f2937" transform="rotate(25 450 270)" />
          <ellipse cx="280" cy="30" rx="36" ry="14" fill="#1f2937" />
          <path d="M100 40 l4 10 l10 4 l-10 4 l-4 10 l-4 -10 l-10 -4 l10 -4 z" fill="currentColor" opacity="0.6" />
          <path d="M460 120 l3 8 l8 3 l-8 3 l-3 8 l-3 -8 l-8 -3 l8 -3 z" fill="currentColor" opacity="0.6" />
          <path d="M180 240 l3 7 l7 3 l-7 3 l-3 7 l-3 -7 l-7 -3 l7 -3 z" fill="#d1d5db" />
          <path d="M400 30 l3 7 l7 3 l-7 3 l-3 7 l-3 -7 l-7 -3 l7 -3 z" fill="#d1d5db" />
          <text
            x="280"
            y="200"
            textAnchor="middle"
            fontSize="170"
            fontWeight="900"
            fill="currentColor"
            fontFamily="Inter, Arial, sans-serif"
            letterSpacing="-6"
          >
            404
          </text>
          <text
            x="280"
            y="250"
            textAnchor="middle"
            fontSize="26"
            fontWeight="800"
            fill="#1f2937"
            fontFamily="Inter, Arial, sans-serif"
            letterSpacing="4"
          >
            ERROR PAGE
          </text>
        </svg>
        <Link
          to="/"
          className="mt-10 rounded-lg bg-[var(--primary)] px-8 py-3.5 text-[15px] font-bold text-white shadow-md transition-colors hover:bg-[var(--primary-hover)]"
        >
          Back to home
        </Link>
      </main>
      <Footer showSecurityNotice={false} />
    </div>
  );
};

export default NotFound;
